<template>
    <div>
        <!-- 顶部导航 -->
        <NavTop></NavTop>
        <!-- 营业执照 -->
        <div class="license row">
            <img src="@/assets/images/yingyezhizhao.jpg" style="width: 100%;">
        </div>
        <!-- 底部 -->
        <Footer></Footer>
    </div>
</template>

<script>
import NavTop from '@/components/NavTop.vue'
import Footer from '@/components/Footer.vue'

export default {
    name: 'LaLicense',
    components: { NavTop, Footer },
    data() {
        return {
        }
    },
    mounted() {

    },
    activated() {

    },
    methods: {


    }

}
</script>

<style scoped>
.license {
    width: 1200px;
    height: auto;
    margin: 20px auto;
    justify-content: space-between;
    position: relative;
}
</style>
